import { ThreatProfileResponse } from '../types/threatProfile';
import { api } from './config'; // Import the configured Axios instance

interface UserIdResponse {
  user_id: string;
}

export const getUserIdByUsername = async (username: string): Promise<UserIdResponse> => {
  const response = await api.get<UserIdResponse>('/api/user/getuserid', {
    params: {
      username: username,
    },
  });
  return response.data;
};

export const getThreatProfile = async (userId: string): Promise<ThreatProfileResponse> => {
  const response = await api.get<ThreatProfileResponse>('/api/user/getthreatprofile', {
    params: {
      user_id: userId,
    },
  });
  return response.data; // Axios wraps the response in a data property
};